import { Quote, Star } from "lucide-react";
import { SITE, TESTIMONIALS } from "@/data/site";
import { useLang } from "@/lib/i18n";

export default function Testimonials() {
  const { t, lang } = useLang();
  return (
    <section data-testid="testimonials" className="section-padding bg-slate-50">
      <div className="container-max">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-yellow-dark">
              {t.home.reviewsEyebrow}
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mt-2 max-w-2xl">
              {t.home.reviewsTitle}
            </h2>
          </div>
          <div className="flex items-center gap-2 text-slate-600">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={18} className="text-amber-400" fill="currentColor" />
              ))}
            </div>
            <span className="font-semibold text-slate-900">4.9/5</span>
            <span className="text-sm">
              {SITE.reviewCount} {lang === "es" ? "reseñas en Google" : "reviews on Google"}
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((tm, idx) => (
            <article
              key={idx}
              data-testid={`testimonial-${idx}`}
              className="bg-white rounded-2xl p-6 border border-slate-200 hover:shadow-lg transition-shadow"
            >
              <Quote size={22} className="text-brand-yellow-dark" />
              <p className="mt-3 text-slate-700 leading-relaxed text-[15px]">
                {lang === "es" ? tm.text_es : tm.text_en}
              </p>
              <div className="mt-5 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-brand-navy text-white flex items-center justify-center font-heading font-bold text-sm">
                  {tm.name.charAt(0)}
                </div>
                <div>
                  <p className="font-heading font-semibold text-slate-900">{tm.name}</p>
                  <p className="text-xs text-slate-500">{tm.location}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
